import { Theme } from '@mui/material/styles'

import { onHover } from '../interaction'

// ----------------------------------------------------------------------

export default function Pagination(theme: Theme) {
  return {
    MuiPagination: {
      defaultProps: {
        color: 'standard' as const,
      },

      styleOverrides: {
        root: {
          '& .MuiPaginationItem-root': {
            fontVariantNumeric: 'tabular-nums',
            ...onHover({ backgroundColor: theme.palette.action.hover }),
            // Current page is a state, so it is ink — not the navy action wash
            // the old color="primary" default painted it with.
            '&.Mui-selected': {
              fontWeight: theme.typography.fontWeightMedium,
              backgroundColor: theme.palette.text.primary,
              color: theme.palette.background.paper,
              // The ink fill IS the state; a wash on top of it would only muddy it.
              ...onHover(
                { backgroundColor: theme.palette.text.primary },
                { backgroundColor: theme.palette.text.primary }
              ),
            },
          },
        },
      },
    },
  }
}
